import { render, staticRenderFns } from "./CallMenuTabsMobile.vue?vue&type=template&id=b1f9ce6c"
import script from "./CallMenuTabsMobile.vue?vue&type=script&lang=js"
export * from "./CallMenuTabsMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports